import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterTitleComponent } from '../../common/filter-title/filter-title.component';
import { Filter } from '../../models/filter-models';
import { SocketedItemType, GearSizeType, VendoringGearType, DisplayType, Rarity } from "../../models/enums";
import { FilterService } from '../../services/filter.service';
import { SelectComponent, SelectOptionComponent } from '../../common/select/select.component';
import { BaseComponent } from '../../common/base.component';
import { socketGroupKeyDown } from '../../common/helper';
import { ActiveRules } from '../../services/filter-generator.service';
import { SelectGearSizeComponent } from '../../common/select/select-gear-size/select-gear-size.component';
import { EquipmentType } from '../../models/equipment-type.enum';
import { VendoringGearComponent } from '../common/vendoring-gear/vendoring-gear.component';
import { EquipmentTierPickerComponent } from '../../common/equipment-tier-picker/equipment-tier-picker.component';

@Component({
  selector: 'app-salvaging-gear-filters-poe2',
  imports: [FormsModule, FilterTitleComponent, SelectComponent, SelectOptionComponent, SelectGearSizeComponent,
    VendoringGearComponent, EquipmentTierPickerComponent],
  templateUrl: './salvaging-gear-filters-poe2.component.html',
  styleUrl: './salvaging-gear-filters-poe2.component.scss'
})
export class SalvagingGearFiltersPoe2Component extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeRules!: ActiveRules;

  SocketedItemType = SocketedItemType;
  GearSizeType = GearSizeType;
  VendoringGearType = VendoringGearType;
  DisplayType = DisplayType;
  Rarity = Rarity;
  EquipmentType = EquipmentType;

  socketGroupKeyDown = socketGroupKeyDown;

  constructor(private filterService: FilterService) {
    super();
  }

  toggleShowVendoringMagics = () => { this.filter.showVendoringMagics = !this.filter.showVendoringMagics; this.updateFilter(); }
  toggleShowSocketedGear = () => { this.filter.showSocketedGear = !this.filter.showSocketedGear; this.updateFilter(); }
  toggleShowQualityMartialWeapons = () => { this.filter.showQualityMartialWeapons = !this.filter.showQualityMartialWeapons; this.updateFilter(); }
  toggleShowQualityCasterWeapons = () => { this.filter.showQualityCasterWeapons = !this.filter.showQualityCasterWeapons; this.updateFilter(); }
  toggleShowQualityArmour = () => { this.filter.showQualityArmour = !this.filter.showQualityArmour; this.updateFilter(); }
  toggleShowQualityFlasks = () => { this.filter.showQualityFlasks = !this.filter.showQualityFlasks; this.updateFilter(); }
  toggleShowQualityCharms = () => { this.filter.showQualityCharms = !this.filter.showQualityCharms; this.updateFilter(); }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
